import React from 'react'

const Purplebutton = ({clickfunc,btnname,w,h,mt}) => {
  return (
    <>
    <div className={`purplebutton w-100`} style={mt?{marginTop:mt}:{}}>

        <button style={{width:w,height:h}}  onClick={clickfunc}>{btnname}</button>
    </div>
    </>
  )
}

export default Purplebutton